<app-modal-card>
  <p class="text-[68px] leading-none" aria-hidden="true">⚠️</p>

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  @if (subtitle()) {
    <p class="text-[14px] fg-gris-1 text-center mt-[12px] whitespace-pre-line">{{ subtitle() }}</p>
  }

  <div class="flex flex-col gap-[10px] w-[400px] mt-auto">
    <form [formGroup]="form" class="mt-[30px]">
      <label class="block text-[16px] font-semibold fg-noir-2">
        {{ reasonLabel() }}<span class="fg-rose-1">*</span>
      </label>
      <textarea
        formControlName="reason"
        [placeholder]="reasonPlaceholder() ?? ''"
        rows="4"
        class="mt-[16px] w-full border border-solid border-gris-3 rounded-[5px] p-[16px] text-[14px] italic resize-none"
      ></textarea>
      @if (requiredErrorMessage() && form.controls.reason.invalid && form.controls.reason.touched) {
        <p class="text-[13px] fg-rose-1 mt-[8px]">{{ requiredErrorMessage() }}</p>
      }
    </form>

    <div class="flex gap-[10px]">
      <button
        type="button"
        class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
        (click)="cancelClick.emit()"
      >
        {{ cancelLabel() }}
        <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
      </button>
      <button
        type="button"
        class="h-[58px] w-full px-[20px] flex items-center justify-center bg-rose-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer disabled:opacity-50"
        [disabled]="form.invalid"
        (click)="onConfirm()"
      >
        {{ confirmLabel() }}
      </button>
    </div>
  </div>
</app-modal-card>
